import { useCallback, useContext } from "react";

import { PageNodesContext } from "../contexts/page-nodes";
import { getNodeFullPath, getNodesMap } from "../utils/pages";

export function usePageFullPath(id?: string) {
  const { pageNodes } = useContext(PageNodesContext);

  if (!id) return null;

  const standardPageNodes = pageNodes ?? [];
  const nodesMap = getNodesMap(standardPageNodes);
  const page = nodesMap[id];

  if (!page) return null;

  return getNodeFullPath(page, nodesMap);
}

export function useGetPageFullPath() {
  const { pageNodes } = useContext(PageNodesContext);

  return useCallback(
    (id: string) => {
      const standardPageNodes = pageNodes ?? [];
      const nodesMap = getNodesMap(standardPageNodes);
      const page = nodesMap[id];

      if (!page) return null;

      return getNodeFullPath(page, nodesMap);
    },
    [pageNodes]
  );
}

export function useGetPagePathByLocale() {
  const { localizedUrls } = useContext(PageNodesContext);

  return useCallback(
    (node_locale: string) => {
      return localizedUrls[node_locale];
    },
    [localizedUrls]
  );
}
